<ng-template #screenOptionTemplate></ng-template>
